(() => {
  // --- CONFIG ---
  const DESIGN_OPTION_NAME = "design";
  const CUSTOM_VALUE = "custom";

  // Keep the last preview URL so we can re-apply after re-renders
  let lastObjectUrl = null;

  function setOverlayVisible(visible) {
  const overlay = document.querySelector("#np-signface-preview");
  if (overlay) overlay.style.display = visible ? "block" : "none";
}

function getTagsFromPage(root = document) {
  // Prefer a product wrapper with data-product-tags
  const el = root.querySelector("[data-product-tags]") || document.body;
  const raw = el?.dataset?.productTags || "";
  return raw
    .split(",")
    .map(t => t.trim().toLowerCase())
    .filter(Boolean);
}

function productNeedsUpload(root = document) {
  const tags = getTagsFromPage(root);
  return tags.includes("needs_upload");
}


  function findDesignFieldset(picker) {
    const sets = picker.querySelectorAll("fieldset.variant-option");
    for (const fs of sets) {
      const legend = fs.querySelector("legend");
      const txt = (legend?.textContent || "").trim().toLowerCase();
      if (txt === DESIGN_OPTION_NAME) return fs;
    }
    return null;
  }

  function isCustomSelected(picker) {
    const fs = findDesignFieldset(picker);
    if (!fs) return false;
    const checked =
      fs.querySelector('input[type="radio"]:checked') ||
      fs.querySelector('input[type="radio"][data-current-checked="true"]');
    const val = (checked?.value || "").trim().toLowerCase();
    return val === CUSTOM_VALUE || val.includes(CUSTOM_VALUE);
  }

  function findActiveMainImage() {
    const gallery =
      document.querySelector("media-gallery") ||
      document.querySelector("[data-media-gallery]") ||
      document.querySelector(".product-information__media") || // prefer your theme wrapper
      document.querySelector(".product__media") ||
      document.querySelector("main");

    if (!gallery) return null;

    const imgs = gallery.querySelectorAll("img");
    if (!imgs.length) return null;

    for (const img of imgs) {
      const hidden =
        img.closest("[hidden]") ||
        img.closest('[aria-hidden="true"]') ||
        img.closest(".is-hidden") ||
        img.closest(".hidden");
      if (!hidden && img.offsetParent !== null) return img;
    }

    return imgs[0];
  }

  function ensureOverlayHost() {
  const host =
    document.querySelector(".product-information__media") ||
    document.querySelector("[data-testid='product-information-media']");

  if (!host) return null;

  host.classList.add("np-preview-host");

  let overlay = host.querySelector("#np-signface-preview");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "np-signface-preview";

    const overlayImg = document.createElement("img");
    overlayImg.alt = "Uploaded design preview";
    overlay.appendChild(overlayImg);

    host.appendChild(overlay);
  } else {
    // If something moved it, put it back
    if (overlay.parentElement !== host) host.appendChild(overlay);
  }

  return overlay;
}



  function setOverlayImage(file) {
    const overlay = ensureOverlayHost();
    if (!overlay) return;

    const img = overlay.querySelector("img");
    if (!img) return;

    if (!file || !file.type?.startsWith("image/")) return;

    if (lastObjectUrl) URL.revokeObjectURL(lastObjectUrl);
    lastObjectUrl = URL.createObjectURL(file);
    img.src = lastObjectUrl;
  }

  function syncAll() {
  const pickers = document.querySelectorAll("variant-picker");

  // CASE 1: Products WITH variant picker
  if (pickers.length) {
    pickers.forEach((picker) => {
      const uploader = document.querySelector("[data-np-uploader]");
      if (!uploader) return;

      const hasDesignOption = !!findDesignFieldset(picker);

      const showUploader = hasDesignOption
        ? isCustomSelected(picker)
        : productNeedsUpload(document);

      uploader.hidden = !showUploader;

      const input = uploader.querySelector("#np-design-file");
      if (!input) return;

      input.required = showUploader;

      if (!showUploader) {
        input.value = "";
        setOverlayVisible(false);
      }
    });
  }

  // CASE 2: Products WITHOUT variant picker
  if (!pickers.length) {
    const uploader = document.querySelector("[data-np-uploader]");
    if (!uploader) return;

    const showUploader = productNeedsUpload(document);
    uploader.hidden = !showUploader;

    const input = uploader.querySelector("#np-design-file");
    if (!input) return;

    input.required = showUploader;

    if (!showUploader) {
      input.value = "";
      setOverlayVisible(false);
    }
  }

  // Keep overlay logic intact
  if (lastObjectUrl) {
    const shouldShow =
      document.querySelector("variant-picker")
        ? isCustomSelected(document.querySelector("variant-picker"))
        : productNeedsUpload(document);

    if (shouldShow) {
      const overlay = ensureOverlayHost();
      const img = overlay?.querySelector("img");
      if (img && img.src !== lastObjectUrl) img.src = lastObjectUrl;
      setOverlayVisible(true);
      scheduleOverlayUpdate();
    } else {
      setOverlayVisible(false);
    }
  }
}


  let raf = null;
  function syncSoon() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      syncAll();
      setTimeout(syncAll, 80);
    });
  }

  function boot() {
    syncSoon();

    document.addEventListener("change", (e) => {
      if (e.target.closest("variant-picker")) syncSoon();
      if (e.target.id === "np-design-file") syncSoon();
    });

    document.addEventListener("click", (e) => {
      if (e.target.closest("variant-picker")) syncSoon();
    });

    const mo = new MutationObserver(syncSoon);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function getVarsFromHost(host) {
  const cs = getComputedStyle(host);
  return {
    leftPct: parseFloat(cs.getPropertyValue("--np-left")) || 0,
    topPct: parseFloat(cs.getPropertyValue("--np-top")) || 0,
    widthPct: parseFloat(cs.getPropertyValue("--np-width")) || 100,
    heightPct: parseFloat(cs.getPropertyValue("--np-height")) || 100,
  };
}

function findVisibleMainImage() {
  // Find the most “visible” product media image
  const gallery =
    document.querySelector("media-gallery") ||
    document.querySelector("[data-media-gallery]") ||
    document.querySelector(".product-information__media") ||
    document.querySelector(".product__media");

  if (!gallery) return null;

  const imgs = gallery.querySelectorAll("img");
  if (!imgs.length) return null;

  for (const img of imgs) {
    const hidden =
      img.closest("[hidden]") ||
      img.closest('[aria-hidden="true"]') ||
      img.closest(".is-hidden") ||
      img.closest(".hidden");
    if (!hidden && img.offsetParent !== null) return img;
  }

  return imgs[0];
}

function updateOverlayToTrackImage() {
  const overlay = document.querySelector("#np-signface-preview");
  if (!overlay) return;

  // Only track while overlay is visible
  if (overlay.style.display === "none") return;

  const img = findVisibleMainImage();
  if (!img) return;

  const host =
    document.querySelector(".product-information__media") ||
    document.querySelector("[data-testid='product-information-media']") ||
    img.closest(".product-information__media") ||
    img.closest(".product__media");

  if (!host) return;

  const r = img.getBoundingClientRect();
  const v = getVarsFromHost(host);

  // Convert your % overlay box into pixels relative to the image rect
  const left = r.left + (r.width * v.leftPct) / 100;
  const top = r.top + (r.height * v.topPct) / 100;
  const width = (r.width * v.widthPct) / 100;
  const height = (r.height * v.heightPct) / 100;

  overlay.classList.add("np-fixed");
  overlay.style.left = `${left}px`;
  overlay.style.top = `${top}px`;
  overlay.style.width = `${width}px`;
  overlay.style.height = `${height}px`;
}

let ticking = false;
function scheduleOverlayUpdate() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    ticking = false;
    updateOverlayToTrackImage();
  });
}

// Keep it synced as you scroll/resize
window.addEventListener("scroll", scheduleOverlayUpdate, { passive: true });
window.addEventListener("resize", scheduleOverlayUpdate);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
